/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.4173 6.014c0 .4286.3543.776.7914.776.437 0 .7913-.3474.7913-.776V0h-6c-.437 0-.7913.3474-.7913.776 0 .4285.3543.776.7913.776h3.3874L17.524 5.4154A2.9862 2.9862 0 0 0 16 5H8C6.3431 5 5 6.3431 5 8v8c0 .5564.1514 1.0773.4154 1.524l-3.8327 3.8327V17.986c0-.4286-.3543-.776-.7914-.776-.437 0-.7913.3474-.7913.776V24h6c.437 0 .7913-.3474.7913-.776 0-.4286-.3542-.776-.7913-.776H2.6126l3.8634-3.8634C6.9227 18.8486 7.4436 19 8 19h8c1.6569 0 3-1.3431 3-3V8a2.9853 2.9853 0 0 0-.4154-1.524l3.8327-3.8326V6.014Zm-6.0288.5368-1.9188 1.9189a.75.75 0 0 0 1.0606 1.0606l1.9189-1.9188c.0331.1239.0508.2541.0508.3885v8c0 .8284-.6716 1.5-1.5 1.5H8a1.5037 1.5037 0 0 1-.3885-.0508l1.9188-1.9189a.75.75 0 0 0-1.0607-1.0606l-1.9188 1.9188A1.5015 1.5015 0 0 1 6.5 16V8c0-.8284.6716-1.5 1.5-1.5h8c.1344 0 .2646.0177.3885.0508Z"
    clipRule="evenodd"
  />,
  'ExpandAll'
);
